import React from 'react';

export type CardRootProps = React.InputHTMLAttributes<HTMLDivElement>;

export type CardHeaderProps = React.InputHTMLAttributes<HTMLDivElement>;

export type CardFooterProps = React.InputHTMLAttributes<HTMLDivElement>;

export type CardContentProps = React.InputHTMLAttributes<HTMLDivElement>;

const Header: React.FC<CardHeaderProps> = (props) => {
  const { className = '', children, ...rest } = props;

  return (
    <div className={'flex items-center border-b-[2px] px-4 py-4 ' + className} {...rest}>
      {children}
    </div>
  );
};

const Content: React.FC<CardContentProps> = (props) => {
  const { className = '', children, ...rest } = props;

  return (
    <div className={'flex px-4 py-4 ' + className} {...rest}>
      {children}
    </div>
  );
};

const Footer: React.FC<CardFooterProps> = (props) => {
  const { className = '', children, ...rest } = props;

  return (
    <div className={'flex items-center border-t-[2px] px-4 py-4 ' + className} {...rest}>
      {children}
    </div>
  );
};

const Root: React.FC<CardRootProps> = (props) => {
  const { className = '', children, ...rest } = props;

  return (
    <div className={'bg-white rounded-md gap-2 ' + className} {...rest}>
      {children}
    </div>
  );
};

export const Card = {
  Root,
  Header,
  Content,
  Footer
};
